export default {
  DYNAMIC: 0,
  CONSTANT: 1,
  GENERATED: 2
}
